import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Setelah navigasi client-side, browser tidak meng-reset scroll.
 * Tanpa ini, dari Home (yang sudah di-scroll) ke halaman lain viewport tetap di posisi lama → terlihat seperti "buka di dekat footer".
 */
export function ScrollToTop() {
  const { pathname, search, hash } = useLocation()

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }, [pathname, search, hash])

  return null
}
